/*
 * @desc get the region
 */
import { getLocal } from './util.js'

let region = ''

export function setRegion(theRegion = '') {
  if (!theRegion) {
    return
  }
  console.log(`interfaces//getRegion/setRegion/${region} => ${theRegion}`)
  region = theRegion || 'IN'
}

export default () => {
  let locale =  getLocal()
  let localeArr = locale.split(';')
  return (region || localeArr[1] || 'IN').toUpperCase()
}


// WEBPACK FOOTER //
// ./src/utils/getRegion.js